import React from 'react';
import { companyInfo } from '../mockData';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-primary)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '60px 7.6923% 40px',
      marginTop: '100px'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '60px',
        marginBottom: '60px'
      }}>
        {/* Brand Column */}
        <div>
          <div style={{
            marginBottom: '20px'
          }}>
            <Logo variant="footer" color="gold" />
          </div>
          <p style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
            margin: 0,
            marginTop: '20px'
          }}>
            Swiss Excellence in International Trade
          </p>
        </div>

        {/* Company Info */}
        <div>
          <h4 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            fontFamily: 'Playfair Display, serif'
          }}>Company</h4>
          <div style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            lineHeight: '1.8'
          }}>
            <p style={{ margin: '0 0 8px 0' }}>{companyInfo.legalName}</p>
            <p style={{ margin: '0 0 8px 0' }}>{companyInfo.address}</p>
          </div>
        </div>

        {/* Contact */}
        <div>
          <h4 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            fontFamily: 'Playfair Display, serif'
          }}>Contact</h4>
          <div style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            lineHeight: '1.8'
          }}>
            <a 
              href={`mailto:${companyInfo.email}`}
              style={{
                color: 'var(--brand-primary)',
                textDecoration: 'none',
                transition: 'opacity 0.3s ease'
              }}
              onMouseOver={(e) => e.target.style.opacity = '0.8'}
              onMouseOut={(e) => e.target.style.opacity = '1'}
            >
              {companyInfo.email}
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{
        borderTop: '1px solid var(--border-subtle)',
        paddingTop: '30px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        <p style={{
          fontSize: '14px',
          color: 'var(--text-muted)',
          margin: 0
        }}>
          © {new Date().getFullYear()} {companyInfo.legalName}. All rights reserved.
        </p>
        <p style={{
          fontSize: '14px',
          color: 'var(--text-muted)',
          margin: 0
        }}>
          Swiss International Trading Company
        </p>
      </div>
    </footer>
  );
};

export default Footer;